import React from "react";
import { connect } from "react-redux";
import { callService, fnToSlash, fnMoneda } from "../tools";
import { reciboPagado } from "./polizas.act";
import { authentication } from '../app-database';
import { conectarFirebase } from '../app-persistance';
import Tarjeta from "./tarjeta.frm";
import ConfirmacionPago from "./confirmacionPago.cmpt";

const mapState = (state) => {
	return {
		"listaAutos": state.polizas.autos,
		"listaGmm": state.polizas.gm,
		"listaVida": state.polizas.vida,
		"listaDanios": state.polizas.danios,
		"poliza": state.polizas.poliza,
		"recibo": state.polizas.recibo,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		reciboPagado: (listaPolizas, numPoliza, numRecibo, ramo) => {
			dispatch(reciboPagado(listaPolizas, numPoliza, numRecibo, ramo));
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo" : sCode });
		},
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento});
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		setRecibo: (oRecibo) => {
			dispatch({ "type": "SET_RECIBO_PAGAR", "recibo": oRecibo });
		},
	};
};

class PagoPoliza extends React.Component {
	nuevoObjetoCobranza=[];

	state = {
		numConfirmacion: 0,
		datosPago: null,
		impTotalReciboUSD: "calculando"
	}

	submit = (data) => {
		data.generales = {
			numRecibo: this.props.recibo.codNumRecibo,
			numPoliza: this.props.poliza.generales.numPoliza,
			codigoIntermediario: this.props.poliza.generales.codIntermediario,
			claveAgente: this.props.poliza.generales.codIntermediario.substr(2,5),
			lineaNegocio: this.props.poliza.generales.cveRamo,
			prodCom: this.props.poliza.generales.cveProdComercial,
			prodTec: this.props.poliza.generales.cveProdTecnico,
			descProd: this.props.poliza.generales.productoComercial,
			fchVigenciaInicial: this.props.poliza.generales.fchVigenciaInicial.split("/").reverse().join("-"),
			fchVigenciaFinal: this.props.poliza.generales.fchVigenciaFinal.split("/").reverse().join("-"),
			periodoCubre: this.props.recibo.fechaEfecRec+" - "+this.props.recibo.fechaVencRec,
			cveCodMoneda: this.props.recibo.cveCodMoneda,
			fechaPago: new Date().getTime()
		};
		
		this.setState({datosPago: data});
		$("#modal-preguntar").modal({backdrop: false, keyboard: false});
	}

	cancelarPago = () => {
		$("#modal-preguntar").modal("hide");
		this.props.addEvento("Cancelar-Pago");
		this.props.tagManager({ "type": "EVENT_PAGARRECIBO-CANCELAR", "dispositivo": this.props.dispositivo });
	}

	confirmarPago = () => {
		$("#modal-preguntar").modal("hide");
		this.props.addEvento("Confirmo-Pago");
		this.pagoTarjeta(this.state.datosPago);
		try {
			let redux = angular.element(document.querySelector("ui-view")).scope().$parent.state.redux;
			redux.dispatch({ "type": "CVE_CLIENTE_UNICO", "uid": authentication.currentUser.uid });
			return conectarFirebase(redux, true);	
		} catch (error) {
			console.log("Error al consultar Firebase"+error);
		}
	}
	

	reciboPagado = () => {
		let listaPolizas = [];

		switch (this.props.poliza.generales.cveRamo) {
		case "A": listaPolizas = this.props.listaAutos; break;
		case "G": listaPolizas = this.props.listaGmm; break;
		case "V": listaPolizas = this.props.listaVida; break;
		case "D": listaPolizas = this.props.listaDanios; break;
		}

		this.props.reciboPagado(
			listaPolizas,
			this.props.poliza.generales.numPoliza,
			this.props.recibo.codNumRecibo,
			this.props.poliza.generales.cveRamo
		);
	}

	pagoTarjeta = (oTarjeta) => {
		let $this = this;
		let serviceUrl = "polizas.pagoTarjeta";
		
		this.props.loader(true);
		if(this.props.poliza.generales.detalle == "capitaliza") {
			//Cambiamos en endPoint para pagos de capitaliza
			serviceUrl = "polizas.pagoTarjetaCapitaliza";
		}
		
		let servicio = new callService({ service: serviceUrl, secure: true, data: oTarjeta }).execute();
		servicio.then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);
			$this.setState({numConfirmacion: respuesta.cobranzaliquidacionResponse.numeroAutorizacion});
			$this.reciboPagado();
			$("#modal-confirmar").modal({backdrop: false, keyboard: false});
			
			// GOOGLE TAG MANAGER //
			if(this.props.recibo.cveCodMoneda == "USD") {
				$this.props.tagManager({ "type": "EVENT_PAGARRECIBO-PAGO-EXITOSO", "dispositivo": $this.props.dispositivo, "monto": this.props.recibo.impTotalRecibo, "moneda": this.props.recibo.cveCodMoneda, "montoCambio": this.state.impTotalReciboUSD });
			} else {
				$this.props.tagManager({ "type": "EVENT_PAGARRECIBO-PAGO-EXITOSO", "dispositivo": $this.props.dispositivo, "monto": this.props.recibo.impTotalRecibo, "moneda": this.props.recibo.cveCodMoneda, "montoCambio": "0.0" });
			}
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			$this.props.alerta(error.message.mensaje);
		});
	}

	componentWillMount = () => {
		let $this = this;
		this.props.loader(true);
		new callService({
			service: "recibos.consultar",
			"secure": true,
			data: {
				"poliza": this.props.poliza.generales.numPoliza,
				"fechaIni": 
				this.props.poliza.generales.fchVigenciaInicial.split("/")[2] + 
				"-" + this.props.poliza.generales.fchVigenciaInicial.split("/")[1] + "-" + 
				this.props.poliza.generales.fchVigenciaInicial.split("/")[0],
				"fechaFin": 
				this.props.poliza.generales.fchVigenciaFinal.split("/")[2] + "-" + 
				this.props.poliza.generales.fchVigenciaFinal.split("/")[1] + "-" + 
				this.props.poliza.generales.fchVigenciaFinal.split("/")[0],
			}
		}).execute().then(oResultado => {
			if (oResultado.registros && oResultado.registros.length > 0) {
				const aRecibos = oResultado.registros.filter(r => r.cveEstadoRecibo == "P");
				if(aRecibos.length > 0) {
					console.log("Recibos pendiente de pago #" + aRecibos.length);
					aRecibos.sort((a,b) => (a.numFraccion - b.numFraccion));
					this.nuevoObjetoCobranza = aRecibos[0];
					console.log("Recibo a pagar: " + aRecibos[0].codNumRecibo);
					this.props.setRecibo(aRecibos[0]);
				}
			}
		
			this.setState({ muestraHTML: true })
	
			this.props.loader(false);
		});

		if(this.props.recibo.cveCodMoneda == "USD") {
			new callService({ 
				service: "polizas.tipoCambio", 
				secure: true, 
				data: { 
					"claveAgente": this.props.poliza.generales.codIntermediario.substr(2,5),
					"numeroRecibo": this.props.recibo.codNumRecibo
				}
			}).execute()
			.then((respuesta) => {
				console.log("Respuesta", respuesta);
				$this.setState({"impTotalReciboUSD": "$ " + fnMoneda(respuesta.importe)});
			}).catch((error) => {
				console.log("Error", error);
				$this.setState({"impTotalReciboUSD": error.message.mensaje});
			});
		}
	}

	tipoMoneda= (tipo) => {
		if(tipo==='MXP'){
			return "Nacional";
		}else if(tipo === 'USD') {
			return 'Dólares';
		}else {
			return "";
		}
	}

	importeRecFuncion = (moneda, cobranza) => {
		console.log(moneda, cobranza);
		if(this.props.recibo.cveCodMoneda) {
			if(this.props.recibo.cveCodMoneda === "USD") {
				return "en "+moneda.toLowerCase();
			}else {
				return "";
			}
		}else {
			if(cobranza === "USD") {
				return "en "+moneda.toLowerCase();
			}else {
				return "";
			}
		}
	}

	importeDineroFuncion = (importe) => {
		if(this.props.recibo.impTotalRecibo) {
			return fnMoneda(this.props.recibo.impTotalRecibo);
		}else {
			return fnMoneda(importe);
		}
	}

	render() {
		console.log('ajnsjdnsjknjdnskjndkjsn',this.props);
		console.log(this.nuevoObjetoCobranza);
		let ramo = "";

		switch (this.props.poliza.generales.cveRamo) {
		case "A": ramo = "Autos"; break;
		case "G": ramo = "Gastos Médicos Mayores"; break;
		case "V": ramo = "Vida"; break;
		case "D": ramo = "Daños"; break;
		}

		let moneda = "";
		if(this.props.recibo.cveCodMoneda){
			moneda = this.tipoMoneda(this.props.recibo.cveCodMoneda);
		}else {
			moneda = this.tipoMoneda(this.nuevoObjetoCobranza.cveCodMoneda);
		}

		let formaPago = "Mensual";

		switch (this.props.poliza.generales.cveFormaPago) {
		case "A": formaPago = "Anual"; break;
		case "M": formaPago = "Mensual"; break;
		case "T": formaPago = "Trimestrial"; break;
		case "S": formaPago = "Semestral"; break;
		case "U": formaPago = "Pago Unico"; break;
		}

		let fechaPeriodo = "";

		if(this.props.recibo.fechaEfecRec) {
			fechaPeriodo = `${fnToSlash(this.props.recibo.fechaEfecRec)} - ${fnToSlash(this.props.recibo.fechaVencRec)}`;
		}else {
			fechaPeriodo = `${fnToSlash(this.nuevoObjetoCobranza.fechaEfecRec)} - ${fnToSlash(this.nuevoObjetoCobranza.fechaVencRec)}`;
		}

		return (
			<div>
				{/*<div style={{"margin":"15px 5px"}}>
					<img onClick={this.props.showPago} src={ require("../img/arrow-back.svg") } />
				</div>*/}
				<div className="card pago-card">
					<div className="row">
						<div className="col-xs-12 col-md-4">
							<i><img src={ require("../img/circle-pago.svg") } alt="" className="pad-right-10" /></i><span className="blue-text">Detalles del pago</span>
							<ul className="list-divider mt-25">
								<li className="clearfix">
									<div className="pull-left">
										<p><b>Número de Póliza</b></p>
									</div>
									<div className="pull-right">
										<div className="gray-text texto15">
											<p name="poliza">{ this.props.poliza.generales.numPoliza }</p>
										</div>
									</div>
								</li>
								<li className="clearfix">
									<div className="pull-left">
										<p><b>Ramo</b></p>
									</div>
									<div className="pull-right">
										<div className="gray-text texto15">
											<p name="ramo">{ ramo }</p>
										</div>
									</div>
								</li>
								<li className="clearfix">
									<div className="pull-left">
										<p><b>Periodo que cubre el recibo</b></p>
									</div>
									<div className="pull-right">
										<div className="gray-text texto15">
											<p name="periodo">{ fechaPeriodo }</p>
										</div>
									</div>
								</li>
								<li className="clearfix">
									<div className="pull-left">
										<p><b>Moneda</b></p>
									</div>
									<div className="pull-right">
										<div className="gray-text texto15">
											<p name="moneda">
												{ moneda }
											</p>
										</div>
									</div>
								</li>
								<li className="clearfix">
									<div className="pull-left">
										<p><b>Número de recibo</b></p>
									</div>
									<div className="pull-right">
										<div className="gray-text texto15">
											<p name="recibo">{ this.props.recibo.codNumRecibo ? this.props.recibo.codNumRecibo : this.nuevoObjetoCobranza.codNumRecibo }</p>
										</div>
									</div>
								</li>
								<li className="clearfix">
									<div className="pull-left">
										<p><b>Producto</b></p>
									</div>
									<div className="pull-right">
										<div className="gray-text texto15">
											<p name="producto">{ this.props.poliza.generales.productoComercial }</p>
										</div>
									</div>
								</li>
								<li className="clearfix">
									<div className="pull-left">
										<p><b>Forma de pago</b></p>
									</div>
									<div className="pull-right">
										<div className="gray-text texto15">
											<p name="pago">{ formaPago }</p>
										</div>
									</div>
								</li>
								<li className="clearfix">
									<div className="pull-left">
										<p>
											<b>Importe del recibo { this.importeRecFuncion(moneda, this.nuevoObjetoCobranza.cveCodMoneda)}</b>
										</p>
									</div>
									<div className="pull-right">
										<div className="gray-text texto15">
											<p name="importe">$ { this.importeDineroFuncion(this.nuevoObjetoCobranza.impTotalRecibo) }</p>
										</div>
									</div>
								</li>
								{ this.props.recibo.cveCodMoneda == "USD" && 
									<li className="clearfix">
										<div className="pull-left">
											<p><b>Importe del recibo en moneda nacional</b></p>
										</div>
										<div className="pull-right">
											<div className="gray-text texto15">
												<p name="importeUSD">{ this.state.impTotalReciboUSD }</p>
											</div>
										</div>
									</li>
								}
								<li style={{"height": "43px"}}></li>
							</ul>
						</div>
						<Tarjeta onSubmit={this.submit} />
					</div>
				</div>

				<div className="modal fade modal-msj" id="modal-preguntar" tabIndex="-1" role="dialog" aria-labelledby="modal-preguntar">
					<div className="modal-backdrop fade in" style={{"zIndex":"0"}}></div>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title orange-text" style={{"padding":"0px"}}>Realizar pago</h4>
							</div>
							<div className="modal-body">
								<p style={{"textAlign":"center"}}>¿Estás seguro que deseas realizar el pago del servicio?</p>
							</div>
							<div className="text-center aceptar-cancelar-btn mt-25 xs-no-mt">
								<a onClick={this.cancelarPago}>Cancelar</a>
								<a onClick={this.confirmarPago} className="orange-btn">Aceptar</a>
							</div>
						</div>
					</div>
				</div>
				<ConfirmacionPago numConfirmacion={this.state.numConfirmacion} />
			</div>
		);
	};
}

export default connect(mapState, mapDispatch)(PagoPoliza);


// WEBPACK FOOTER //
// ./src/home/pago.cmpt.js